// DELETE SOCIAL SUBSCRIBERS //

export const DELETE_FACEBOOK = "DELETE_FACEBOOK";
export const DELETE_FACEBOOK_SUCCESS = "DELETE_FACEBOOK_SUCCESS";
export const DELETE_FACEBOOK_FAIL = "DELETE_FACEBOOK_FAIL";

export const DELETEALL_FACEBOOK = "DELETEALL_FACEBOOK";
export const DELETEALL_FACEBOOK_SUCCESS = "DELETEALL_FACEBOOK_SUCCESS";
export const DELETEALL_FACEBOOK_FAIL = "DELETEALL_FACEBOOK_FAIL";

export const DELETE_INSTAGRAM = "DELETE_INSTAGRAM";
export const DELETE_INSTAGRAM_SUCCESS = "DELETE_INSTAGRAM_SUCCESS";
export const DELETE_INSTAGRAM_FAIL = "DELETE_INSTAGRAM_FAIL";

export const DELETEALL_INSTAGRAM = "DELETEALL_INSTAGRAM";
export const DELETEALL_INSTAGRAM_SUCCESS = "DELETEALL_INSTAGRAM_SUCCESS";
export const DELETEALL_INSTAGRAM_FAIL = "DELETEALL_INSTAGRAM_FAIL";

export const DELETE_TWITTER = "DELETE_TWITTER";
export const DELETE_TWITTER_SUCCESS = "DELETE_TWITTER_SUCCESS";
export const DELETE_TWITTER_FAIL = "DELETE_TWITTER_FAIL";

export const DELETEALL_TWITTER = "DELETEALL_TWITTER";
export const DELETEALL_TWITTER_SUCCESS = "DELETEALL_TWITTER_SUCCESS";
export const DELETEALL_TWITTER_FAIL = "DELETEALL_TWITTER_FAIL";

export const DELETE_YOUTUBE = "DELETE_YOUTUBE";
export const DELETE_YOUTUBE_SUCCESS = "DELETE_YOUTUBE_SUCCESS";
export const DELETE_YOUTUBE_FAIL = "DELETE_YOUTUBE_FAIL";

export const DELETEALL_YOUTUBE = "DELETEALL_YOUTUBE";
export const DELETEALL_YOUTUBE_SUCCESS = "DELETEALL_YOUTUBE_SUCCESS";
export const DELETEALL_YOUTUBE_FAIL = "DELETEALL_YOUTUBE_FAIL";

export const DELETE_TIKTOK = "DELETE_TIKTOK";
export const DELETE_TIKTOK_SUCCESS = "DELETE_TIKTOK_SUCCESS";
export const DELETE_TIKTOK_FAIL = "DELETE_TIKTOK_FAIL";

export const DELETEALL_TIKTOK = "DELETEALL_TIKTOK";
export const DELETEALL_TIKTOK_SUCCESS = "DELETEALL_TIKTOK_SUCCESS";
export const DELETEALL_TIKTOK_FAIL = "DELETEALL_TIKTOK_FAIL";

export const DELETE_CONTACT = "DELETE_CONTACT";
export const DELETE_CONTACT_SUCCESS = "DELETE_CONTACT_SUCCESS";
export const DELETE_CONTACT_FAIL = "DELETE_CONTACT_FAIL";

export const DELETEALL_CONTACT = "DELETEALL_CONTACT";
export const DELETEALL_CONTACT_SUCCESS = "DELETEALL_CONTACT_SUCCESS";
export const DELETEALL_CONTACT_FAIL = "DELETEALL_CONTACT_FAIL";

export const DELETE_SUBSCRIBER = "DELETE_SUBSCRIBER";
export const DELETE_SUBSCRIBER_SUCCESS = "DELETE_SUBSCRIBER_SUCCESS";
export const DELETE_SUBSCRIBER_FAIL = "DELETE_SUBSCRIBER_FAIL";

export const DELETEALL_SUBSCRIBER = "DELETEALL_SUBSCRIBER";
export const DELETEALL_SUBSCRIBER_SUCCESS = "DELETEALL_SUBSCRIBER_SUCCESS";
export const DELETEALL_SUBSCRIBER_FAIL = "DELETEALL_SUBSCRIBER_FAIL";
